import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Logo from "assets/images/svg/everycred-logo.svg";
import SidebarNavItem from "components/SidebarNavItem";
// import { BiTachometer, BiLogOut } from "react-icons/bi";
import { BiLogOut } from "react-icons/bi";
import { CgTemplate } from "react-icons/cg";

// import { FiSettings } from "react-icons/fi";
// import { BsCardList } from "react-icons/bs";
// import { MdInfoOutline } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
// import { CgUserList } from "react-icons/cg";
import useWidth from "utils/useWidth";
import { useDispatch } from "react-redux";
import { toggleLogoutModal } from "store/commonActions";
import SidebarWithMidbar from "../SidebarWithMidbar/SidebarWithMidbar";

const useStyles = makeStyles((theme) => ({
  siteAside: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 4,
    "& ::-webkit-scrollbar": {
      width: 0,
      height: 0,
      background: "transperent",
    },
    [theme.breakpoints.down("xl")]: {
      width: "100px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "106px",
    },
  },
  sidebarLeftSide: {
    borderRight: "none",
    boxShadow: "1.5px 1.5px 3px 0 rgba(0, 0, 0, 0.1)",
    background: "#f6f6f6",
    position: "relative",
    [theme.breakpoints.down("xl")]: {
      padding: "15px 15px 0",
    },
    [theme.breakpoints.up("xl")]: {
      padding: "26px 18px 18px",
    },
  },
  sidebarLogo: {
    padding: "0",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("xl")]: {
      margin: "0 auto 70px",
      width: "36px",
      height: "44px",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "20px auto 30px",
      // width: 80,
      // height: 70,
    },
    [theme.breakpoints.down("xs")]: {
      margin: "10px 0 20px",
      width: "100%",
      // height: "100%",
    },
    // [theme.breakpoints.up("xl")]: {
    //   margin: "0 auto 60px",
    //   width: "42px",
    //   height: "48px",
    // },
    "& img": {
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.down("xs")]: {
        width: "60%",
      },
    },
  },
  sideBarNav: {
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "0 10px",
    },
  },
  sidebarNavLi: {
    padding: 0,
    [theme.breakpoints.down("xl")]: {
      margin: "0 0 20px",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "0 0 0px",
    },
    [theme.breakpoints.up("xl")]: {
      margin: "0 0 18px",
    },
  },
  sidebarNavItemIcon: {
    lineHeight: 0,
    "& svg": {
      height: "auto",
      width: "16px",
    },
  },
  sidebarNavItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    border: "1px solid #d5d5d5",
    background: "#ffffff",
    borderRadius: "20px",
    color: "#848484",
    width: "100%",
    textDecoration: "none",
    cursor: "pointer",
    [theme.breakpoints.down("xl")]: {
      padding: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: 10,
      margin: "5px 0",
    },
    "&:hover": {
      color: "#ffffff",
      background: "#083f85",
      "& .nav-icon-wrap": {
        background: "#ffffff",
        "& i": {
          color: "#083f85",
        },
      },
    },
  },
  activeLink: {
    color: "#ffffff",
    background: "#083f85",
    "& .nav-icon-wrap": {
      background: "#ffffff",
      "& i": {
        color: "#083f85",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
    "&::after": {
      [theme.breakpoints.down("xl")]: {
        right: "-15px",
      },
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      [theme.breakpoints.up("xl")]: {
        right: "-18px",
      },
      content: `' '`,
      position: "absolute",
      backgroundColor: "#083f85",
      width: 3,
      height: 25,
      top: "50%",
      transform: "translate(0, -50%)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      width: "0",
      height: "0",
      left: "97%",
      top: "50%",
      transform: "translate(0, -50%)",
      borderTop: "10px solid transparent",
      borderBottom: "10px solid transparent",
      [theme.breakpoints.down("xl")]: {
        borderLeft: "8px solid #083f85",
      },
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
      [theme.breakpoints.up("xl")]: {
        borderLeft: "12px solid #083f85",
      },
    },
  },
  sidebarNavItemText: {
    fontSize: "10px",
    fontFamily: "Roboto",
    fontWeight: "400",
    display: "Block",
  },
  iconWrap: {
    height: "32px",
    width: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    background: "#f6f6f6",
    [theme.breakpoints.down("xl")]: {
      margin: "0 0 6px",
    },
    [theme.breakpoints.up("xl")]: {
      margin: "0 0 8px",
    },
  },
}));

function Sidebar({ display, openDrawer, handleClose, setOpenDrawer }) {
  const classes = useStyles();
  const width = useWidth();
  const dispatch = useDispatch();

  if (!display) return null;

  const handleLogout = (event) => {
    dispatch(toggleLogoutModal());
  };

  return (
    <>
      {openDrawer && width === "xs" ? (
        <SidebarWithMidbar
          display={display}
          handleClose={handleClose}
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
        />
      ) : (
        <Drawer
          variant={
            !openDrawer && width !== "xs" && width !== "sm"
              ? "permanent"
              : "temporary"
          }
          className={classes.siteAside}
          open={openDrawer}
          onClose={handleClose}
          classes={{ paperAnchorDockedLeft: classes.sidebarLeftSide }}
        >
          <i className={classes.sidebarLogo}>
            <img src={Logo} alt="Everycred Logo" />
          </i>
          <List className={classes.sideBarNav}>
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path="/users"
                exact={true}
                itemName="Users"
                icon={<HiOutlineUserGroup />}
              />
            </ListItem>

            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path="/themes"
                exact={false}
                itemName="Themes"
                icon={<CgTemplate />}
              />
            </ListItem>
            {/*
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path='/issuers'
                exact={false}
                itemName='Issuers'
                icon={<HiOutlineUserGroup />}
              />
            </ListItem>
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path='/subjects'
                exact={false}
                itemName='Subjects'
                icon={<BsCardList />}
              />
            </ListItem>
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path='/activities'
                exact={false}
                itemName='Logs'
                icon={<CgUserList />}
              />
            </ListItem>
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path='/settings'
                exact={false}
                itemName='Settings'
                icon={<FiSettings />}
              />
            </ListItem>
            <ListItem className={classes.sidebarNavLi}>
              <SidebarNavItem
                path='/about'
                exact={true}
                itemName='About'
                icon={<MdInfoOutline />}
              />
            </ListItem> */}
            <ListItem className={classes.sidebarNavLi} onClick={handleLogout}>
              <div className={classes.sidebarNavItem}>
                <div className={`${classes.iconWrap} nav-icon-wrap`}>
                  <i className={`${classes.sidebarNavItemIcon}`}>
                    <BiLogOut />
                  </i>
                </div>
                <span className={classes.sidebarNavItemText}>Logout</span>
              </div>
            </ListItem>
          </List>
        </Drawer>
      )}
    </>
  );
}

export default React.memo(Sidebar);
